export interface NoticeDto {
    seq: number | null,
    title: string,
    content: string,
    attachmentFileName: string,
    checked?: boolean
}

export const InitialNoticeDto: NoticeDto = {
    seq: null,
    title: "",
    content: "",
    attachmentFileName: ""
}